<template>
	<div>
        <b-modal size="lg" :hide-footer="true" id="announcement-detail" :title="(announcementDetail.AnnouncementGroup ? announcementDetail.AnnouncementGroup + ': ' : '') + (announcementDetail.Subject || '') + (announcementDetail.CreateTime ? ' - ' + announcementDetail.CreateTime : '')" no-close-on-esc no-close-on-backdrop>
            <announcement-detail v-model="announcementDetail"></announcement-detail>
        </b-modal>

        <!-- ===================== OKUNMAMIŞ DUYURULAR (TAM GENİŞLİK) ===================== -->
        <div class="row">
            <div class="col-12 mb-1">
                <b-card no-body class="border mb-0">
                    <div class="p-1">
                        <div class="d-flex justify-content-between align-items-center mb-75">
                            <h6 class="font-weight-bolder mb-0">
                                <span class="material-icons-round align-middle" style="font-size:1.1rem">notifications</span>
                                Okunmamış Duyurular
                            </h6>
                            <b-badge variant="danger" v-if="unreadAnnouncements.length">{{unreadAnnouncements.length}}</b-badge>
                        </div>
                        <div class="row" v-if="unreadAnnouncements.length">
                            <div v-for="a in unreadAnnouncements.slice(0,6)" :key="a.Id" class="col-12 col-md-6 col-lg-4 mb-75">
                                <div class="d-flex justify-content-between align-items-start border rounded p-75 h-100 announcement-item" v-on:click="openAnnouncement(a)">
                                    <div class="mr-1">
                                        <div class="font-weight-bolder small">{{a.Subject || a.AnnouncementGroup || '-'}}</div>
                                        <small class="text-muted">{{a.CreateTime}}</small>
                                    </div>
                                    <span class="text-nowrap d-flex align-items-center">
                                        <b-spinner small class="mr-50" v-if="announcementLoadingId == a.Id"></b-spinner>
                                        <b-badge variant="light-danger">okunmadı</b-badge>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-muted small">Okunmamış duyuru yok.</div>
                    </div>
                </b-card>
            </div>
        </div>

        <!-- ===================== KPI ŞERİDİ ===================== -->
        <div class="row kpi-row">
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Günlük Tahsilat" variant="warning" icon="currency_lira" :loading="summaryLoading" :value="summary ? summary.TodayCollection : '0,00'"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Aylık Tahsilat" variant="danger" icon="currency_lira" :loading="summaryLoading" :value="summary ? summary.ThisMonthCollection : '0,00'"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Önceki Ay Tahsilat" variant="secondary" icon="event_repeat" :loading="summaryLoading" :value="summary ? summary.PrevMonthCollection : '0,00'"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Toplam Açık Bakiye" variant="info" icon="account_balance_wallet" :loading="summaryLoading" :value="summary ? summary.TotalOpenBalance : '0,00'"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Vade Geçmiş (>40g)" :short-text="summary ? ('%' + summary.OverdueRatio) : null" variant="danger" icon="report" :loading="summaryLoading" :value="summary ? summary.OverdueBalance : '0,00'"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Bekleyen Link" variant="warning" icon="hourglass_top" :loading="summaryLoading" :value="summary ? summary.PendingLinkCount : 0"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="Süresi Dolan Link" variant="danger" icon="link_off" :loading="summaryLoading" :value="summary ? summary.ExpiredLinkCount : 0"></v-stats-box>
            </div>
            <div class="col-6 col-md-4 col-lg-3 mb-1">
                <v-stats-box text="GÜNEŞ Fırsat" variant="success" icon="wb_sunny" :loading="summaryLoading" :value="summary ? summary.SunOpportunityCount : 0"></v-stats-box>
            </div>
        </div>

        <!-- ===================== TAHSİLAT TRENDİ (TAM GENİŞLİK + TARİH FİLTRESİ) ===================== -->
        <b-overlay :show="trendLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-1">
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-1">
                    <h4 class="font-weight-bolder mb-50 mb-md-0 mr-1">
                        Tahsilat Trendi
                        <span v-if="trend" class="text-success d-block d-md-inline ml-md-50">Toplam: {{trend.Total}} ₺</span>
                    </h4>
                    <div class="d-flex flex-wrap align-items-center trend-filter">
                        <input type="date" class="form-control form-control-sm trend-date mr-50" v-model="trendStart" />
                        <span class="mr-50">–</span>
                        <input type="date" class="form-control form-control-sm trend-date mr-50" v-model="trendEnd" />
                        <button class="btn btn-primary btn-sm text-nowrap trend-apply" v-on:click="getTrend">Uygula</button>
                    </div>
                </div>
                <app-echart-bar v-if="trend && trend.Points && trend.Points.length" :key="'tr-'+trend.StartDate+trend.EndDate" style="width:100%;height:360px" :option-data="trendChart"></app-echart-bar>
                <div v-else-if="!trendLoading" class="text-center text-muted py-2">Veri bulunmamaktadır.</div>
                <div v-else style="height:360px"></div>
            </b-card>
        </b-overlay>

        <!-- ===================== TAKSİT / TAHSİLAT FIRSATI ===================== -->
        <b-overlay :show="oppLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-75">
                    <h4 class="font-weight-bolder mb-0 mr-1">Taksit / Tahsilat Fırsatı</h4>
                    <small class="text-muted" v-if="installmentOpp">
                        Taksit açık: {{installmentOpp.TaksitAcikCount}} · Son gün: {{installmentOpp.SonGunCount}} · Tek çekim: {{installmentOpp.TekCekimCount}} · Kilitli: {{installmentOpp.KilitliCount}}
                    </small>
                </div>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-0 stack-table">
                        <thead>
                            <tr>
                                <th>Durum</th>
                                <th class="text-nowrap">Cari</th>
                                <th class="text-nowrap text-right">Kalan Borç</th>
                                <th class="text-nowrap">Taksit Son Gün</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in installmentItems" :key="c.CustomerCode">
                                <td class="text-nowrap" data-label="Durum">
                                    <span class="badge" :class="badgeClass(c.Badge)">{{c.BadgeLabel}}</span>
                                    <span v-if="c.HasSunProduct" class="material-icons-round text-warning align-middle" style="font-size:1rem" title="GÜNEŞ faturası">wb_sunny</span>
                                </td>
                                <td class="text-nowrap" data-label="Cari">
                                    <div class="font-weight-bolder">{{c.CustomerName || '-'}}</div>
                                    <small class="text-muted">{{c.CustomerCode}} · {{c.OpenInvoiceCount}} fatura</small>
                                    <div class="mt-25">
                                        <a :href="'/CustomerAccountDetail/'+c.CustomerCode" target="_blank" class="btn btn-outline-primary btn-sm py-0 px-50 text-nowrap" title="Cari detayını yeni sekmede aç">Cari Detay <span class="material-icons-round align-middle" style="font-size:0.9rem">open_in_new</span></a>
                                    </div>
                                </td>
                                <td class="text-nowrap text-right font-weight-bolder" data-label="Kalan Borç">{{c.TotalRemainingDebt}}</td>
                                <td class="text-nowrap" data-label="Taksit Son Gün">{{c.NearestInstallmentLastDay || '-'}}</td>
                            </tr>
                            <tr v-if="installmentItems.length == 0">
                                <td colspan="4" class="text-center text-muted" data-label="">Veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <!-- ===================== AKTİF ÖDEME LİNKLERİ (BEKLEYEN, TIKLANABİLİR) ===================== -->
        <b-overlay :show="linkLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-75">
                    <h4 class="font-weight-bolder mb-0 mr-1">Aktif Ödeme Linkleri (Bekleyen)</h4>
                    <small class="text-muted">{{ (linkStatus && linkStatus.IsAdmin) ? 'Tüm plasiyerler' : 'Size ait' }} · süresi dolmamış</small>
                </div>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-0 stack-table">
                        <thead>
                            <tr>
                                <th class="text-nowrap" v-if="linkStatus && linkStatus.IsAdmin">Gönderen</th>
                                <th class="text-nowrap">Cari</th>
                                <th class="text-nowrap text-right">Tutar</th>
                                <th class="text-nowrap">Kalan Süre</th>
                                <th class="text-nowrap">İşlem</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="l in activePendingLinks" :key="l.Id">
                                <td class="text-nowrap" data-label="Gönderen" v-if="linkStatus && linkStatus.IsAdmin">{{l.RequesterUserName || '-'}}</td>
                                <td class="text-nowrap" data-label="Cari">
                                    <div>
                                        <span class="font-weight-bolder">{{l.CariName || l.CariCode || '-'}}</span>
                                        <span v-if="l.IsSunProduct" class="material-icons-round text-warning align-middle" style="font-size:1rem" title="GÜNEŞ faturası">wb_sunny</span>
                                    </div>
                                    <div class="mt-25" v-if="l.CariCode">
                                        <a :href="'/CustomerAccountDetail/'+l.CariCode" target="_blank" class="btn btn-outline-primary btn-sm py-0 px-50 text-nowrap" title="Cari detayını yeni sekmede aç">Cari Detay <span class="material-icons-round align-middle" style="font-size:0.9rem">open_in_new</span></a>
                                    </div>
                                </td>
                                <td class="text-nowrap text-right font-weight-bolder" data-label="Tutar">{{l.TotalAmount || '-'}}</td>
                                <td class="text-nowrap" data-label="Kalan Süre">{{l.RemainingHours != null ? (l.RemainingHours + ' saat') : '-'}}</td>
                                <td class="text-nowrap" data-label="İşlem">
                                    <a v-if="l.GroupCode" :href="'/Payment/'+l.GroupCode" target="_blank" class="btn btn-outline-primary btn-sm">Aç</a>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                            <tr v-if="activePendingLinks.length == 0">
                                <td :colspan="linkStatus && linkStatus.IsAdmin ? 5 : 4" class="text-center text-muted" data-label="">Aktif bekleyen link bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <!-- ===================== GÜNEŞ: TAKSİT YAPILABİLİR (col-12, fatura bazında, müşteri gruplu) ===================== -->
        <b-overlay :show="sunLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <h4 class="font-weight-bolder mb-1 d-flex flex-wrap align-items-center">
                    <span class="material-icons-round text-warning mr-50">wb_sunny</span>
                    <span class="mr-50">GÜNEŞ — Taksit Yapılabilir</span>
                    <small v-if="sun" class="text-success font-weight-bold">({{sun.OpportunityCariCount}} cari · {{sun.OpportunityCount}} fatura · {{sun.OpportunityTotal}})</small>
                </h4>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-0 stack-table">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Cari</th>
                                <th class="text-nowrap">Fatura No</th>
                                <th class="text-nowrap">Fatura Tarihi</th>
                                <th class="text-nowrap">Vade Tarihi</th>
                                <th class="text-nowrap text-right">Kalan Borç</th>
                                <th class="text-nowrap">Durum</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(f,i) in sunOpportunities" :key="'so-'+f.BelgeNo+'-'+i" :class="{'border-top-bold': f._first}">
                                <td class="text-nowrap" data-label="Cari">
                                    <div class="font-weight-bolder">{{f.CustomerName || '-'}}</div>
                                    <small class="text-muted">{{f.CustomerCode}}</small>
                                    <div class="mt-25">
                                        <a :href="'/CustomerAccountDetail/'+f.CustomerCode" target="_blank" class="btn btn-outline-primary btn-sm py-0 px-50 text-nowrap" title="Cari detayını yeni sekmede aç">Cari Detay <span class="material-icons-round align-middle" style="font-size:0.9rem">open_in_new</span></a>
                                    </div>
                                </td>
                                <td class="text-nowrap" data-label="Fatura No">{{f.BelgeNo || '-'}}</td>
                                <td class="text-nowrap" data-label="Fatura Tarihi">{{f.Tarih || '-'}}</td>
                                <td class="text-nowrap" data-label="Vade Tarihi">{{f.VadeTarihi || '-'}}</td>
                                <td class="text-nowrap text-right font-weight-bolder" data-label="Kalan Borç">{{f.RemainingDebt}}</td>
                                <td class="text-nowrap" data-label="Durum"><span class="badge badge-light-success">Taksit yapılabilir</span></td>
                            </tr>
                            <tr v-if="sunOpportunities.length == 0"><td colspan="6" class="text-center text-muted" data-label="">Veri bulunmamaktadır.</td></tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <!-- ===================== GÜNEŞ: VADE KAÇTI — TEK ÇEKİM (col-12, fatura bazında, müşteri gruplu) ===================== -->
        <b-overlay :show="sunLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <h4 class="font-weight-bolder mb-1 d-flex flex-wrap align-items-center">
                    <span class="material-icons-round text-danger mr-50">wb_sunny</span>
                    <span class="mr-50">GÜNEŞ — Vade Kaçtı (Tek Çekim)</span>
                    <small v-if="sun" class="text-danger font-weight-bold">({{sun.OverdueCariCount}} cari · {{sun.OverdueCount}} fatura · {{sun.OverdueTotal}})</small>
                </h4>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-0 stack-table">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Cari</th>
                                <th class="text-nowrap">Fatura No</th>
                                <th class="text-nowrap">Fatura Tarihi</th>
                                <th class="text-nowrap">Vade Tarihi</th>
                                <th class="text-nowrap">Gecikme</th>
                                <th class="text-nowrap text-right">Kalan Borç</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(f,i) in sunOverdue" :key="'sv-'+f.BelgeNo+'-'+i" :class="{'border-top-bold': f._first}">
                                <td class="text-nowrap" data-label="Cari">
                                    <div class="font-weight-bolder">{{f.CustomerName || '-'}}</div>
                                    <small class="text-muted">{{f.CustomerCode}}</small>
                                    <div class="mt-25">
                                        <a :href="'/CustomerAccountDetail/'+f.CustomerCode" target="_blank" class="btn btn-outline-primary btn-sm py-0 px-50 text-nowrap" title="Cari detayını yeni sekmede aç">Cari Detay <span class="material-icons-round align-middle" style="font-size:0.9rem">open_in_new</span></a>
                                    </div>
                                </td>
                                <td class="text-nowrap" data-label="Fatura No">{{f.BelgeNo || '-'}}</td>
                                <td class="text-nowrap" data-label="Fatura Tarihi">{{f.Tarih || '-'}}</td>
                                <td class="text-nowrap" data-label="Vade Tarihi">{{f.VadeTarihi || '-'}}</td>
                                <td class="text-nowrap text-danger font-weight-bolder" data-label="Gecikme">{{f.OverdueDays}} gün</td>
                                <td class="text-nowrap text-right font-weight-bolder" data-label="Kalan Borç">{{f.RemainingDebt}}</td>
                            </tr>
                            <tr v-if="sunOverdue.length == 0"><td colspan="6" class="text-center text-muted" data-label="">Veri bulunmamaktadır.</td></tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <!-- ===================== MEVCUT TABLOLAR (KORUNDU) ===================== -->
        <b-overlay :show="rupsLoading" opacity="0.2" v-if="isResponsible">
            <b-card class="mt-1" body-class="p-75" >
                <h2 class="p-25 font-weight-bolder">Sorumlu Olunan Günlük İşlem Hareketleri</h2>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1 stack-table">
                        <thead>
                            <tr>
                                <th>İşlemler</th>
                                <th class="text-nowrap w-10">Cari Kod</th>
                                <th class="text-nowrap w-10">İşlem Zamanı</th>
                                <th class="text-nowrap w-10">Talep Eden Kullanıcı</th>
                                <th class="text-nowrap w-10">Son Yanıtlama Tarihi</th>
                                <th class="text-nowrap w-10">Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Ortalama Gün</th>
                                <th class="text-nowrap w-20">Durum</th>
                                <th class="text-nowrap w-10">Tutar (TL)</th>
                                <th class="text-nowrap w-10">Son Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Açıklama</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in responsibleUserPaymentStatuses" >
                                <tr :key="ps.Id">
                                    <td data-label="">
                                        <button class="btn btn-primary btn-sm d-flex align-items-center" v-if="ps.Status == 0" v-on:click="approve(ps)">
                                            <b-spinner small class="mr-50" v-if="approving && cid == ps.Id"></b-spinner>
                                            Onayla
                                        </button>
                                    </td>
                                    <td class="text-nowrap" data-label="Cari Kod">{{$safe(ps,'CariCode') || '-'}}</td>
                                    <td class="text-nowrap" data-label="İşlem Zamanı">{{$safe(ps,'DateStr') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Talep Eden Kullanıcı">{{$safe(ps,'RequesterUserName') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Son Yanıtlama Tarihi">{{$safe(ps,'ResponsibleUserLastApproveDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Yanıt Tarihi">{{$safe(ps,'ResponsibleUserApproveDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Ortalama Gün">{{$safe(ps,'AverageDate') || '-'}}</td>
                                    <td class="text-nowrap font-weight-bolder" data-label="Durum">{{$safe(ps,'StatusStr') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Tutar (TL)">{{$safe(ps,'TotalAmount') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Son Ödeme Tarihi">{{$safe(ps,'InvoiceLastPaymentDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Ödeme Tarihi">{{$safe(ps,'InvoicePaymentDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Açıklama">{{$safe(ps,'Description') || '-'}}</td>
                                </tr>
                                <tr :key="ps.Id + '-dl'" v-if="ps.DocumentList">
                                    <td colspan="20" data-label="">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-34">Fatura Numarası</th>
                                                    <th class="text-nowrap w-33">Fatura Kesim Tarihi</th>
                                                    <th class="text-nowrap w-33">Borç</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="dl in ps.DocumentList" :key="dl.DocumentNo">
                                                        <td>{{$safe(dl,'DocumentNo') || '-'}}</td>
                                                        <td>{{$safe(dl,'Date') || '-'}}</td>
                                                        <td>{{$safe(dl,'Debt') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="responsibleUserPaymentStatuses.length == 0">
                                <td colspan="20" class="text-center" data-label="">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

        <b-overlay :show="psLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <h2 class="p-25 font-weight-bolder">Günlük İşlem Hareketleri</h2>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1 stack-table">
                        <thead>
                            <tr>
                                <th>İşlemler</th>
                                <th class="text-nowrap w-5">Grup Kodu</th>
                                <th class="text-nowrap w-5">Cari Kod</th>
                                <th class="text-nowrap w-10">Cari Adı</th>
                                <th class="text-nowrap w-10">İşlem Zamanı</th>
                                <th class="text-nowrap w-10">Sor. Kul.</th>
                                <th class="text-nowrap w-10">Sor. Kul. Son Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Sor. Kul. Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Ortalama Gün</th>
                                <th class="text-nowrap w-10">Açıklama</th>
                                <th class="text-nowrap w-10">Son Ödeme Tarihi</th>
                                <th class="text-nowrap w-10">Ödeme Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in paymentStatuses" >
                                <tr :key="ps.Id">
                                    <td data-label="">
                                        <button class="btn btn-primary btn-sm d-flex align-items-center" v-if="ps.Status == 2" v-on:click="approveRequestAgain(ps)">
                                            <b-spinner small class="mr-50" v-if="pending && cid == ps.Id"></b-spinner>
                                            Onaya gönder
                                        </button>
                                    </td>
                                    <td class="text-nowrap" data-label="Grup Kodu">
                                        <a :href="'/Payment/'+ps.InvoiceGroupCode" target="_blank">{{$safe(ps,'InvoiceGroupCode') || '-'}}</a>
                                    </td>
                                    <td class="text-nowrap" data-label="Cari Kod">{{$safe(ps,'CariCode') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Cari Adı">{{$safe(ps,'CariName') || '-'}}</td>
                                    <td class="text-nowrap" data-label="İşlem Zamanı">{{$safe(ps,'DateStr') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Sor. Kul.">{{$safe(ps,'ResponsibleUserName') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Sor. Kul. Son Yanıt Tarihi">{{$safe(ps,'ResponsibleUserLastApproveDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Sor. Kul. Yanıt Tarihi">{{$safe(ps,'ResponsibleUserApproveDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Ortalama Gün">{{$safe(ps,'AverageDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Açıklama">{{$safe(ps,'Description') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Son Ödeme Tarihi">{{$safe(ps,'InvoiceLastPaymentDate') || '-'}}</td>
                                    <td class="text-nowrap" data-label="Ödeme Tarihi">{{$safe(ps,'InvoicePaymentDate') || '-'}}</td>
                                </tr>
                                <tr :key="ps.Id + '-dl'" v-if="ps.DocumentList">
                                    <td colspan="20" data-label="">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-20">Durum</th>
                                                    <th class="text-nowrap w-20">Fatura Numarası</th>
                                                    <th class="text-nowrap w-20">Fatura Kesim Tarihi</th>
                                                    <th class="text-nowrap w-10">Borç</th>
                                                    <th class="text-nowrap w-10">Ödenen Tutar</th>
                                                    <th class="text-nowrap w-10">Kalan Tutar</th>
                                                    <th class="text-nowrap w-10">Fazla Ödenen Tutar</th>
                                                </thead>
                                                <tbody>
                                                    <tr :class="setPaymentStatusColor(dl.Status)" v-for="dl in ps.DocumentList" :key="dl.DocumentNo">
                                                        <td class="text-nowrap font-weight-bolder">{{$safe(dl,'StatusStr') || '-'}}</td>
                                                        <td>{{$safe(dl,'DocumentNo') || '-'}}</td>
                                                        <td>{{$safe(dl,'Date') || '-'}}</td>
                                                        <td>{{$safe(dl,'Debt') || '-'}}</td>
                                                        <td>{{$safe(dl,'PaidPart') || '-'}}</td>
                                                        <td>{{$safe(dl,'RemainingDebt') || '-'}}</td>
                                                        <td>{{$safe(dl,'OverPaymentPart') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="paymentStatuses.length == 0">
                                <td colspan="20" class="text-center" data-label="">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

	</div>
</template>

<script>
import { BCard, BCardText, BLink,BImg,BOverlay,BSpinner,BBadge,BModal } from 'bootstrap-vue'
import {PaymentApi} from '@/api/payment'
import {ReportApi} from '@/api/report'
import {AnnouncementApi} from '@/api/announcement'
import VStatsBox from '@/components/VStatsBox.vue'
import AppEchartBar from '@/@core/components/charts/echart/AppEchartBar.vue'
import AnnouncementDetail from './announcement/components/AnnouncementDetail.vue'
import Auth from '@/utilities/auth'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

function fmtDate(d){
    const pad = n => String(n).padStart(2,'0')
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
}

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BImg,
        BBadge,
        BModal,
        VStatsBox,
        VuePerfectScrollbar,
        BOverlay,
        BSpinner,
        AppEchartBar,
        AnnouncementDetail
    },
    data() {
        const end = new Date()
        const start = new Date()
        start.setDate(start.getDate() - 29)
        return {
            paymentStatuses:[],
            responsibleUserPaymentStatuses:[],
            psLoading:false,
            rupsLoading:false,
            approving:false,
            cid:null,
            pending:false,
            // --- Dashboard ---
            summary:null,
            summaryLoading:false,
            trend:null,
            trendLoading:false,
            trendStart:fmtDate(start),
            trendEnd:fmtDate(end),
            installmentOpp:null,
            oppLoading:false,
            linkStatus:null,
            linkLoading:false,
            sun:null,
            sunLoading:false,
            unreadAnnouncements:[],
            announcementDetail:{ Id:null, Subject:null, Content:null, CreateTime:null, AnnouncementGroup:null },
            announcementLoadingId:null
        }
    },
    mounted(){
        this.getPaymentStatuses()
        if(this.isResponsible){
            this.getResponisbleUserPaymentStatuses()
        }
        // Dashboard verileri
        this.getDashboardSummary()
        this.getTrend()
        this.getInstallmentOpportunity()
        this.getLinkStatus()
        this.getSunActions()
        this.getUnreadAnnouncements()
    },
    computed:{
        isResponsible(){
            return Auth.isResponsible
        },
        trendChart(){
            const points = (this.trend && this.trend.Points) || []
            const labels = points.map(p => (p.Date || '').substring(0,5))
            const values = points.map(p => p.AmountValue)
            return {
                grid: { left:'3%', right:'4%', bottom:'3%', top:'12%', containLabel:true },
                tooltip: {
                    trigger:'axis',
                    formatter: params => {
                        const p = params[0]
                        const v = Number(p.value || 0).toLocaleString('tr-TR')
                        return `${p.axisValue}<br/><b>${v} ₺</b>`
                    }
                },
                xAxis: { type:'category', data: labels },
                yAxis: { type:'value', axisLabel:{ formatter: val => Number(val).toLocaleString('tr-TR') } },
                series: [{ name:'Tahsilat', type:'bar', barMaxWidth:26, data: values, itemStyle:{ color:'#08a1ae', borderRadius:[3,3,0,0] } }]
            }
        },
        installmentItems(){
            return (this.installmentOpp && this.installmentOpp.Items) ? this.installmentOpp.Items : []
        },
        sunOpportunities(){
            return this.groupByCustomer(this.sun && this.sun.Opportunities)
        },
        sunOverdue(){
            return this.groupByCustomer(this.sun && this.sun.OverdueSinglePayment)
        },
        activePendingLinks(){
            return (this.linkStatus && this.linkStatus.Items ? this.linkStatus.Items : [])
                .filter(l => l.Category == 'pending')
                .slice(0,25)
        }
    },
    methods:{
        badgeClass(badge){
            switch(badge){
                case 'taksit_acik': return 'badge-light-success'
                case 'son_gun': return 'badge-light-warning'
                case 'kilitli': return 'badge-light-dark'
                case 'tek_cekim': return 'badge-light-danger'
                default: return 'badge-light-secondary'
            }
        },
        setPaymentStatusColor(paymentStatus){
            if(paymentStatus == 6 || paymentStatus == 7)
                return 'bg-light-success'
            if(paymentStatus == 5)
                return 'bg-light-primary'
            if(paymentStatus == 4 || paymentStatus == 2)
                return 'bg-light-danger'
            if(paymentStatus == 0)
                return 'bg-light-info'
                if(paymentStatus == 3)
                return 'bg-light-warning'
            return ''
        },
        groupByCustomer(list){
            let prev = null
            return (list || []).map(r => {
                const first = r.CustomerCode !== prev
                prev = r.CustomerCode
                return Object.assign({}, r, { _first:first })
            })
        },
        getDashboardSummary(){
            this.summaryLoading = true
            ReportApi.CollectionDashboardSummary().then(res=>{
                this.summary = res.data.Data
                this.summaryLoading = false
            }).catch(()=>this.summaryLoading = false)
        },
        getTrend(){
            this.trendLoading = true
            ReportApi.CollectionTrend({ StartDate:this.trendStart, EndDate:this.trendEnd }).then(res=>{
                this.trend = res.data.Data
                this.trendLoading = false
            }).catch(()=>this.trendLoading = false)
        },
        getInstallmentOpportunity(){
            this.oppLoading = true
            ReportApi.CariInstallmentOpportunity().then(res=>{
                this.installmentOpp = res.data.Data
                this.oppLoading = false
            }).catch(()=>this.oppLoading = false)
        },
        getLinkStatus(){
            this.linkLoading = true
            ReportApi.PaymentLinkStatus().then(res=>{
                this.linkStatus = res.data.Data
                this.linkLoading = false
            }).catch(()=>this.linkLoading = false)
        },
        getSunActions(){
            this.sunLoading = true
            ReportApi.SunCampaignActions().then(res=>{
                this.sun = res.data.Data
                this.sunLoading = false
            }).catch(()=>this.sunLoading = false)
        },
        getUnreadAnnouncements(){
            AnnouncementApi.Table({ Skip:0, Take:30 }).then(res=>{
                const data = (res.data.Data && res.data.Data.Data) ? res.data.Data.Data : []
                this.unreadAnnouncements = data.filter(a => !a.IsRead)
            }).catch(()=>{})
        },
        openAnnouncement(a){
            this.announcementLoadingId = a.Id
            AnnouncementApi.Detail(a.Id).then(res=>{
                this.announcementLoadingId = null
                if(res.data.Success){
                    this.announcementDetail = res.data.Data
                    this.$showModal('announcement-detail')
                    this.getUnreadAnnouncements()
                }
            }).catch(err=>{
                this.announcementLoadingId = null
                this.$result(null,err)
            })
        },
        getPaymentStatuses(){
            this.psLoading = true
            PaymentApi.SalesmanPaymentStatusList().then(res=>{
                this.psLoading = false
                this.paymentStatuses = res.data.Data
            }).catch(()=>this.psLoading = false)
        },
        getResponisbleUserPaymentStatuses(){
            this.rupsLoading = true
            PaymentApi.ResponsibleUserPaymentStatusList().then(res=>{
                this.responsibleUserPaymentStatuses = res.data.Data
                this.rupsLoading = false
            }).catch(()=>this.rupsLoading = false )
        },
        approve(ps){
            this.cid = ps.Id
            this.approving = true
            PaymentApi.ApproveInstallment(ps.InvoiceGroupCode).then(res=>{
                this.$result(res)
                this.approving = false
                if(res.data.Success){
                    this.getResponisbleUserPaymentStatuses()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.approving = false
            })
        },
        approveRequestAgain(ps){
            this.cid = ps.Id
            this.pending = true
            PaymentApi.ApproveRequestAgain(ps.InvoiceGroupCode).then(res=>{
                this.$result(res)
                this.pending = false
                if(res.data.Success){
                    this.getPaymentStatuses()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.pending = false
            })
        }
    }
}
</script>

<style>
.card-wrapper{
    max-height:calc(100vh - 22rem);
    overflow-x:auto;
}
.border-top-bold > td{
    border-top:2px solid #08a1ae !important;
}

/* Okunmamış duyuru kartları tıklanabilir */
.announcement-item{
    cursor:pointer;
    transition:border-color .15s, background-color .15s;
}
.announcement-item:hover{
    border-color:#08a1ae !important;
    background-color:#f5fcfc;
}

/* Trend tarih filtresi: dar ekranda Uygula taşmasın */
.trend-date{ width:auto; }
@media (max-width:575.98px){
    .trend-filter{ width:100%; }
    .trend-date{ flex:1 1 0; min-width:0; }
    .trend-apply{ flex:1 1 100%; margin-top:.45rem; }
}

/* KPI kutuları: büyük tutarlar dar ekranda taşmasın */
.kpi-row .truncate{
    white-space:normal;
    overflow:visible;
    text-overflow:clip;
    min-width:0;
}
.kpi-row h2{
    word-break:break-word;
    line-height:1.2;
}
@media (max-width:991.98px){
    .kpi-row h2{ font-size:1.35rem; }
    .kpi-row .card-body{ padding:0.9rem !important; }
}
@media (max-width:575.98px){
    .kpi-row h2{ font-size:1.1rem; }
    .kpi-row .card-body{ padding:0.75rem !important; }
    /* küçük ekranda ikonu gizle, sayıya tam genişlik bırak */
    .kpi-row .b-avatar{ display:none !important; }
}

/* Dar ekranda tablolar: yatay scroll yerine kart/yığın görünüm.
   Yalnızca doğrudan-çocuk hücreleri hedefler; yuvalı alt-tablolar etkilenmez. */
@media (max-width:767.98px){
    .card-wrapper{ overflow-x:hidden; }
    table.stack-table > thead{ display:none; }
    table.stack-table,
    table.stack-table > tbody,
    table.stack-table > tbody > tr,
    table.stack-table > tbody > tr > td{ display:block; width:100%; }
    table.stack-table > tbody > tr{ margin-bottom:0.6rem; border:1px solid #ebe9f1; border-radius:0.4rem; padding:0.35rem 0.65rem; }
    table.stack-table > tbody > tr > td{ border:0 !important; padding:0.18rem 0 !important; text-align:left !important; white-space:normal !important; }
    table.stack-table > tbody > tr > td.text-right{ text-align:left !important; }
    table.stack-table > tbody > tr > td::before{
        content:attr(data-label);
        display:block;
        font-size:0.68rem;
        font-weight:600;
        color:#6e6b7b;
        text-transform:uppercase;
        letter-spacing:.2px;
    }
    table.stack-table > tbody > tr > td[data-label='']::before{ display:none; }
}

@media screen and (max-width:767px) {
    .card-wrapper{
        max-height:calc(100vh - 30rem);
    }
}
</style>
